/*eslint-disable*/
export const GATEWAY_API_BASEPATH = process.env.REACT_APP_GATEWAY_API_BASEPATH
export const GATEWAY_BULK_API_BASEPATH = process.env.REACT_APP_GATEWAY_BULK_API_BASEPATH
export const GATEWAY_SURVEY_API_BASEPATH = process.env.REACT_APP_GATEWAY_SURVEY_API_BASEPATH

export const GATEWAY_API_HEALTH_URL = `${GATEWAY_API_BASEPATH}/health`

export const GATEWAY_API_USER_URL = `${GATEWAY_API_BASEPATH}/userinfo`

export const GATEWAY_API_DATA_URL = `${GATEWAY_API_BASEPATH}/data`

export const GATEWAY_API_USERS_URL = `${GATEWAY_API_BASEPATH}/users`

export const GATEWAY_API_GROUPS_URL = `${GATEWAY_API_BASEPATH}/groups`

export const GATEWAY_API_APPS_URL = `${GATEWAY_API_BASEPATH}/apps`

export const GATEWAY_API_ERROR_URL = `${GATEWAY_API_BASEPATH}/error`

export const GATEWAY_API_CAMPIAGN_URL = `${GATEWAY_API_BASEPATH}/campaigns`

export const GATEWAY_API_USER_REGISTERED_APPS_URL = `${GATEWAY_API_BASEPATH}/api/me/applications`

// export const GATEWAY_API_BULK_USER_UPLOAD_URL = `${GATEWAY_API_BASEPATH}/users/bulk-upload`

// export const GATEWAY_API_BULK_USER_STATUS_URL = `${GATEWAY_API_BASEPATH}/users/bulk-upload-status`

export const GATEWAY_API_USER_ACTIVITIES_URL = `${GATEWAY_API_BASEPATH}/audits`

export const GATEWAY_API_BULK_USER_UPLOAD_URL = `${GATEWAY_BULK_API_BASEPATH}/bulk-upload`

export const GATEWAY_API_BULK_USER_STATUS_URL = `${GATEWAY_BULK_API_BASEPATH}/reporting/status`

export const GATEWAY_BULK_API_HEALTH_URL = `${GATEWAY_BULK_API_BASEPATH}/health`

export const SURVEY_TEMPLATES_URL = `${GATEWAY_SURVEY_API_BASEPATH}/surveys/survey-templates`

export const GATEWAY_API_SURVEY_URL = `${GATEWAY_SURVEY_API_BASEPATH}/surveys`
